import { render, staticRenderFns } from "./recapCommerciaux.vue?vue&type=template&id=22cfbd2e&scoped=true&"
import script from "./recapCommerciaux.vue?vue&type=script&lang=js&"
export * from "./recapCommerciaux.vue?vue&type=script&lang=js&"
import style0 from "./recapCommerciaux.vue?vue&type=style&index=0&id=22cfbd2e&scoped=true&lang=scss&"
import style1 from "./recapCommerciaux.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cfbd2e",
  null
  
)

export default component.exports